<template>
  <tabs parent="diadoc">
    <tab
        id="documents"
        :name="translate('diadoc.tabs.documents')"
        :href="url+'documents'"
    >
      <Documents :group_list="group_list"/>
    </tab>

    <tab
        id="counterparties"
        :name="translate('diadoc.tabs.counterparties')"
        :href="url+'counterparties'"
    >
      <Counterparties />
    </tab>

    <tab
        id="groups"
        :name="translate('diadoc.tabs.groups')"
        :href="url+'groups'"
    >
      <Groups :groups="groups"/>
    </tab>

    <tab
        id="policies"
        :name="translate('diadoc.tabs.policies')"
        :href="url+'policies'"
    >
      <Policies />
    </tab>

    <tab
        id="history"
        :name="translate('diadoc.tabs.history')"
        :href="url+'history'"
    >
      <History />
    </tab>

  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Documents from './Tabs/Documents/Documents.vue'
import Counterparties from './Tabs/Counterparties/Counterparties.vue'
import Groups from './Tabs/Groups/Groups.vue'
import Policies from "./Tabs/Policies/Policies.vue";
import History from "./Tabs/History/History.vue";


export default {
  name: 'Diadoc',
  components:{
    Tab,
    Tabs,
    Documents,
    Counterparties,
    Groups,
    Policies,
    History
  },
  props: {
  },
  data () {
    return {
      load: true,
      groups: []
    }
  },
  computed: {
    url () { return '/diadoc/' },
    group_list(){
      return this.groups.map(item => {
        return { id: item.id, label: item.name}
      })
    }
  },

  created () {
    this.get_diadoc_group_list()
  },

  methods: {
    get_diadoc_group_list(){
      this.$http.v1.getDiadocGroupList((response) => {
        this.groups = response.data
      })
    },
  }

}
</script>
